module.exports = __webpack_public_path__ + "static/media/image5.50196c8d.png";